// Packages
import PropTypes from 'prop-types'

// Components
import SettingsForm from 'modules/Settings/components/Form';

// Other
import useApi from 'hooks/useApi';

const SettingsEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/settings/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Setting updated!')) {

            onSubmit();
        }
    }

    return(
        <SettingsForm 
            errors={errors} 
            item={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

SettingsEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

SettingsEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default SettingsEditScreen;